import superagent from 'superagent'

const featureData = {
  // V2 resolves features from the tapped coordinate against PostgreSQL directly, so it takes
  // lat/lon plus the layer ids instead of the WMS GetFeatureInfo URL V1 wanted per layer.
  // returnGeometry is per-request here, where V1 carried it on each layer entry.
  get: ({ latitude, longitude, zoomLevel, returnGeometry = false, layerIds }, token) => {
    return new Promise((resolve, reject) => {
      superagent
        .post(`${__API_URI_2__}/FeatureInfo/get`)
        .set('Authorization', `Bearer ${token}`)
        .set('content-type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send({ latitude, longitude, zoomLevel, returnGeometry, layerIds })
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  }
}

export default featureData
